const makeSelectFilterOption = (searchValue, inputValue) => {
  return searchValue.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0;
};


export default makeSelectFilterOption;
